<template>
  <el-container>
    <div id="header">
      <img
        :src="defaultImg"
        alt=""
        style="width: 100%; height: 92vh"
        id="defaultImage"
      />
      <div class="header-title">
        <p style="width: 288px;height: 45px;font-size: 32px;font-family: PingFang-SC-Bold, PingFang-SC;font-weight: bold;color: #FFFFFF;line-height: 45px;">不负韶华、不负时代</p>
        <p style="width: 224px;height: 20px;font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #FFFFFF;line-height: 20px;">加入我们，携手共建大屏端内容生态</p>
      </div>
      <!-- 轮播图 -->
      <div class="slideshow" id="slideshow" style="width: 1200px">
        <!-- 上一张按钮 -->
        <span class="spin" @click="switchImg(-1)">
          <i class="el-icon-arrow-left"></i>
        </span>
        <div class="container" id="box">
          <ul ref="showImg">
            <li
              v-for="(item, index) in imgArr"
              :key="index"
              :class="{ currentImg: index === selected }"
            >
              <img :src="item.src" alt="" @mouseover="mouseoverImg" />
              <div class="applicationForm" :id="item.src">申请合作</div>
            </li>
            <!-- 把图片复制一份到最后，实现循环滚动无回滚 -->
            <li
              v-for="(item, index) in imgArr"
              :key="index + 'info'"
              :class="{ currentImg: index === selected }"
            >
              <img :src="item.src" alt="" @mouseover="mouseoverImg" />
              <div class="applicationForm" :id="item.src">申请合作</div>
            </li>
          </ul>
        </div>
        <!-- 下一张按钮 -->
        <span
          class="next"
          @click="switchImg(-2)"
        >
          <i class="el-icon-arrow-right"></i>
        </span>
      </div>
    </div>
    <!-- 主体 -->
    <el-main style="width: 1200px; margin: 0 auto">
      <div class="top1">
        <p>Supported Cooperation Contents</p>
        <h2 class="topTitle">支持合作的内容</h2>
        <el-row style="height: 200px"> </el-row>
      </div>
      <div class="top2">
        <p>Our Advantages in OT</p>
        <h2 class="topTitle">我们在大屏端端优势</h2>
        <el-row class="top2Animate">
          <el-col :span="6">
            <dl>
              <dt><img src="../../assets/home-image/dpqd.png" class="transitionDiv" /></dt>
              <dd>亿级会员流量算法精准匹配</dd>
            </dl>
          </el-col>
          <el-col :span="6">
            <dl>
              <dt><img src="../../assets/home-image/qgfg.png" /></dt>
              <dd>亿级会员流量算法精准匹配</dd>
            </dl>
          </el-col>
          <el-col :span="6">
            <dl>
              <dt><img src="../../assets/home-image/hwyw.png" /></dt>
              <dd>亿级会员流量算法精准匹配</dd>
            </dl>
          </el-col>
          <el-col :span="6">
            <dl>
              <dt><img src="../../assets/home-image/mxcp.png" /></dt>
              <dd>亿级会员流量算法精准匹配</dd>
            </dl>
          </el-col>
        </el-row>
      </div>
      <div class="top3">
        <p>Business Cooperation</p>
        <h2 class="topTitle">业务合作流程</h2>
        <el-row>
          <el-col :span="3">
            <dl>
              <dt><img src="../../assets/home-image/register.png" /></dt>
              <dd>注册账号</dd>
              <dd class="topNum">1</dd>
            </dl>
          </el-col>
          <el-col :span="4" style="margin-top: 12%">
            <div class="topArrows"></div>
          </el-col>
          <el-col :span="3">
            <dl>
              <dt><img src="../../assets/home-image/hz.png" /></dt>
              <dd>申请合作类型</dd>
              <dd class="topNum">2</dd>
            </dl>
          </el-col>
          <el-col :span="4" style="margin-top: 12%">
            <div class="topArrows"></div>
          </el-col>
          <el-col :span="3">
            <dl>
              <dt><img src="../../assets/home-image/qy.png" /></dt>
              <dd>签约</dd>
              <dd class="topNum">3</dd>
            </dl>
          </el-col>
          <el-col :span="4" style="margin-top: 12%">
            <div class="topArrows"></div>
          </el-col>
          <el-col :span="3">
            <dl>
              <dt><img src="../../assets/home-image/sy.png" /></dt>
              <dd>获取收益</dd>
              <dd class="topNum">4</dd>
            </dl>
          </el-col>
        </el-row>
      </div>
      <div class="top4">
        <p>Cooperative Partner</p>
        <h2 class="topTitle">合作伙伴</h2>
        <el-row style="margin-bottom: 20px">
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
          <el-col :span="4"><img src="../../assets/home-image/dsj.png" alt="" /></el-col>
        </el-row>
      </div>
    </el-main>
    <div class="top5">
      <h2 class="topTitle5">欢迎入驻</h2>
      <div>
        <el-button round class="topButton">即刻申请</el-button>
      </div>
    </div>
    <el-footer>
      <el-row style="margin-top: 20px">
        <el-col :span="7">
          <img
            src="../../assets/logo.png"
            alt=""
            style="vertical-align: middle; width: 200px"
          />
        </el-col>
        <el-col :span="10">
          <!-- <el-breadcrumb separator="|">
            <el-breadcrumb-item>网站首页</el-breadcrumb-item>
            <el-breadcrumb-item>关于我们</el-breadcrumb-item>
            <el-breadcrumb-item>用户协议</el-breadcrumb-item>
            <el-breadcrumb-item>隐私协议</el-breadcrumb-item>
            <el-breadcrumb-item>联系我们</el-breadcrumb-item>
          </el-breadcrumb> -->
          <p class="breadcrumb">
            <span>网站首页</span>
            <span>|</span>
            <span>关于我们</span>
            <span>|</span>
            <span>用户协议</span>
            <span>|</span>
            <span>隐私协议</span>
            <span>|</span>
            <span>联系我们</span>
          </p>
          <p class="rightCopy">
            Copyright © 2005-2020 youwebip 京ICP证12345 版权所有
          </p>
        </el-col>
        <el-col :span="7">
          <div style="color: white">二维码</div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  name: 'home',
  data () {
    return {
      imgArr: [
        { id: 1, src: require('../../assets/home-image/dsj.png') },
        { id: 2, src: require('../../assets/home-image/dsj.png') },
        { id: 3, src: require('../../assets/home-image/dsj.png') },
        { id: 4, src: require('../../assets/home-image/dsj.png') },
        { id: 5, src: require('../../assets/home-image/dsj.png') }
      ],
      defaultImg:'',
      selected: 0, // 当前展示的图片
      imgWidth: 200, // 图片宽度
      flag: true, // 节流阀，防止连续点击切换
      // currentId: 1,
      num: document.documentElement.clientHeight || document.body.clientHeight, // 浏览器可视高度
      config: false, // 阻止第一次向下滚动到底
      config1: false // 类名top4，第一次出现在可视界面，淡入效果
    }
  },
  watch: {},
  mounted () {
    // 监听鼠标滚动(轮播图盒子的动画)
    window.addEventListener(
      'mousewheel',
      // this.debounce(this.handleScroll, 0),
      this.handleScroll
    ) ||
      window.addEventListener(
        'DOMMouseScroll',
        // this.debounce(this.handleScroll, 0),
        this.handleScroll
      )
    // 监听鼠标滚动(主体图片出现在可视窗口时的动画)
    window.addEventListener('mousewheel', this.handleScroll1) ||
      window.addEventListener('DOMMouseScroll', this.handleScroll1)
  },
  methods: {
    // 函数防抖
    debounce (func, wait) {
      let timeout
      return function () {
        const context = this
        const args = arguments
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait)
      }
    },
    // 判断滚动方向 并滑动
    handleScroll (e) {
      const app = document.getElementById('app')
      const swiper = document.getElementById('slideshow')
      if (e.wheelDelta > 0 && document.documentElement.scrollTop == 0) {
        // 当鼠标滚轮向上滚动时
        app.style.transition = '1s'
        app.style.transform = 'translateY(0vh)'
        swiper.style.transition = '2s'
        swiper.style.transform = 'translateY(0vh)'
        console.log('向上')
      }
      if (
        e.wheelDelta < 0 &&
        document.documentElement.scrollTop == 0 &&
        !this.config
      ) {
        // 当鼠标滚轮向下滚动时
        app.style.transition = '1s'
        app.style.transform = 'translateY(-100vh)'
        swiper.style.transition = '2s'
        swiper.style.transform = 'translateY(85vh)'
        console.log('向下')
        document.body.style.overflow = 'hidden'
      }
      this.config = true
      if (this.config) {
        setTimeout(() => {
          document.body.style.overflow = 'auto'
          this.config = false
        }, 1000)
      }
    },
    // 主体图片出现在可视窗口时
    handleScroll1 () {
      // 获取的是浏览器可见区域高度
      var documentClientHeight =
        document.documentElement.clientHeight || window.innerHeight
      // 元素顶端到可见区域顶端的距离
      var htmlElementClientTop = document
        .querySelectorAll('.top2 img')[0]
        .getBoundingClientRect().top
      // console.log(htmlElementClientTop)
      // 网页指定元素进入可视区域
      if (documentClientHeight >= htmlElementClientTop && !this.config1) {
        // TODO
        // var img = document.querySelectorAll('.top2 img')[0]
        //  img.classList.add('transitionDiv')
        var img = document.getElementsByClassName('top2Animate')[0]
        img.style.transform = 'translateY(-50px)'
        this.fadeIn(img, 200)
        this.config1 = true
      }
    },
    // 鼠标移入图片
    mouseoverImg (e) {
      // var defaultImage = document.getElementById('defaultImage')
      // this.fadeIn(defaultImage, 500)
      this.defaultImg = e.target.src
    },
    // 图片淡入动画
    fadeIn (obj, time) {
      // 淡入函数  实现time毫秒后显示，原理是根据透明度来完成的
      var startTime = new Date()
      obj.style.opacity = 0.5 // 设置下初始值透明度
      obj.style.display = 'block'
      var timer = setInterval(function () {
        var nowTime = new Date()
        var prop = (nowTime - startTime) / time
        if (prop >= 1) {
          prop = 1 // 设置最终系数值
          clearInterval(timer)
        }
        obj.style.opacity = prop // 透明度公式： 初始值+系数*（结束值-初始值）
      }, 100) // 每隔100ms执行一次function函数
    },
    // 走马灯动画
    animate (moveX, callback) {
      if (this.flag) {
        this.flag = false // 关闭节流阀，每次调用动画函数回调函数中打开
        const ulX = this.$refs.showImg.offsetLeft
        console.log(ulX)
        const target = ulX + moveX // 求出移动的目标位置
        this.swiper = setInterval(() => {
          // 创建定时器移动元素
          let step = (target - this.$refs.showImg.offsetLeft) / 10 // 实现由快到慢的过渡效果
          step = step > 0 ? Math.ceil(step) : Math.floor(step) // 对每次移动的距离取整
          const startX = this.$refs.showImg.offsetLeft // 求出元素的当前位置
          if (this.$refs.showImg.offsetLeft === target) {
            // 移动完成
            clearInterval(this.swiper) // 清除先前已经创建的定时器
            callback && callback()
            return
          }
          this.$refs.showImg.style.left = startX + step + 'px' // 移动
        }, 15)
      }
    },
    // 点击上一张，下一张
    switchImg (index) {
      if (index === -1) {
        // 上一张
        if (this.selected === 0) {
          // 如果是第一张
          if (!this.flag) return // 防止连点bug
          index = this.imgArr.length
          this.$refs.showImg.style.left = -index * this.imgWidth + 'px' // 显示至最后一张
          this.animate(this.imgWidth, () => {
            this.selected = this.imgArr.length - 1 // 显示上一张
            this.flag = true
          })
        } else {
          this.animate(this.imgWidth, () => {
            // 显示上一张
            this.selected--
            this.flag = true
          })
        }
      } else if (index === -2) {
        // 下一张
        if (this.selected === this.imgArr.length - 1) {
          // 如果是倒数第二张
          index = this.imgArr.length
          this.animate(-this.imgWidth, () => {
            // 显示下一张
            this.selected = 0
            this.$refs.showImg.style.left = 0
            // this.$refs.showImg.style.paddingLeft = 0;
            this.flag = true
          })
        } else {
          this.animate(-this.imgWidth, () => {
            this.selected++ // 显示至第一张
            this.flag = true
          })
        }
      }
    }
  }
}
</script>
<style scoped>
.header-title{
  width: 100%;
  align-items: center;
  position: absolute;
  bottom: 50%;
  display: flex;
  flex-direction: column;
}
.topTitle {
  height: 50px;
  font-size: 38px;
}
dd {
  margin: 10px 0;
  width: 100%;
  text-align: center;
}
.topArrows {
  margin-left: 26%;
  width: 120px;
  height: 2px;
  background: linear-gradient(90deg, rgba(171, 175, 193, 0) 0%, #72778e 100%);
}
.top1 {
  height: 80vh;
  margin-top: 10%;
}
.top2 {
  height: 70vh;
  margin-top: 10%;
}

.top1 p,
.top2 p,
.top3 p,
.top4 p {
  font-size: 22px;
}
.top2 img {
  width: 200px;
  height: 200px;
}
.top3 img,
.top4 img {
  width: 100px;
  height: 100px;
}
.topNum {
  width: 20px;
  height: 20px;
  background: #7f63f2;
  border-radius: 50%;
  text-align: center;
  margin-left: 45%;
}
.top5 {
  background: #1d0b28;
  height: 200px;
  line-height: 100px;
}
.topButton {
  background: #7f63f2;
  color: white;
  border: none;
}
.topTitle5 {
  color: white;
  height: 50px;
}
.rightCopy {
  font-size: 12px;
  color: white;
  margin-top: 10%;
}
.el-footer {
  height: 150px !important;
  background: #242a31;
  color: #333;
  text-align: center;
  /* line-height: 150px; */
}
.breadcrumb {
  color: white;
}
.breadcrumb span {
  margin: 0 5px;
  font-size: 14px;
}
.app-wrapper .app-main.el-main {
  width: 100%;
  padding: 0px;
}
.el-main {
  color: #333;
  text-align: center;
}

body > .el-container {
  margin-bottom: 40px;
}
/* 轮播图样式 */
#box {
  width: 1000px;
  position: relative;
  overflow: hidden;
}
#box ul {
  width: 300%;
  position: absolute;
  left: 0;
  padding: 0;
  list-style: none;
  height: 233px;
  overflow: hidden;
}
#box ul li {
  width: 200px;
  height: 233px;
  float: left;
  transform: translateY(33px);
  transition: all 500ms;
}

#box ul li img {
  display: block;
  width: 200px;
  height: 200px;
}

#box ul li:hover {
  transform: translateY(0);
}

.applicationForm {
  width: 100%;
  background-color: #7f63f2;
  color: white;
  text-align: center;
  font-size: 20px;
  padding: 5px 0;
}
.slideshow {
  z-index: 1000;
  width: 100%;
  height: 251px;
  position: absolute;
  bottom: 50px;
  display: flex;
  justify-content: space-around;
  right: 10%;
}
.top2Animate {
  margin-top: 100px;
  transform: translateY(0);
  transition: transform 200ms ease 100ms;
}
.spin {
  line-height: 251px;
  color: orange;
  font-size: 30px;
}
.next {
  line-height: 251px;
  color: orange;
  font-size: 30px;
}
</style>
